module.exports = __webpack_public_path__ + "static/media/Trading-in-a-car-with-body-damage-Brisbane.ae420762.jpg";